module.exports = __webpack_public_path__ + "static/img/peopleGame3.c520812.webp";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/peopleGame3.webp
// module id = h0OJ
// module chunks = 3